// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Anchor_anchor__3TokD","button":"Anchor_button__3ogU6","buttonText":"Anchor_buttonText__2WhNb","lg":"Anchor_lg__dWlin","link":"Anchor_link__r7wx4"};